import type { ReactNode } from 'react';
import { Check } from 'lucide-react';

import { cn } from '../../lib/cn';
import styles from './wizard.module.css';

interface Props {
  step: number; // 0..3
  steps: string[];
  children: ReactNode;
  foot: ReactNode;
}

function BrandLogo() {
  return (
    <svg viewBox="0 0 100 100" width="36" height="36" aria-hidden="true">
      <circle cx="50" cy="50" r="46" fill="#FFCD2E" stroke="#0E0E10" strokeWidth="3.5" />
      <path
        d="M30 42c2-2 6-2 8 0M62 42c2-2 6-2 8 0"
        stroke="#0E0E10"
        strokeWidth="4.5"
        fill="none"
        strokeLinecap="round"
      />
      <path
        d="M36 60c4 5 10 7 14 7s10-2 14-7"
        stroke="#0E0E10"
        strokeWidth="4.5"
        fill="none"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function WizardShell({ step, steps, children, foot }: Props) {
  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <header className={styles.head}>
          <div className={styles.brand}>
            <BrandLogo />
            <div>
              <strong className={styles.brandTitle}>FocusMode OS</strong>
              <small className={styles.brandSub}>הגדרת חשבון · {String(steps.length)} שלבים</small>
            </div>
          </div>
        </header>

        <div className={styles.stepbar} aria-label="התקדמות">
          {steps.map((label, i) => {
            const state = i < step ? 'done' : i === step ? 'active' : '';
            return (
              <div
                key={label}
                className={cn(styles.step, state === 'done' && styles.done, state === 'active' && styles.active)}
              >
                <div className={styles.stepNum}>
                  {i < step ? <Check size={12} /> : i + 1}
                </div>
                <div className={styles.stepLabel}>{label}</div>
                {i < steps.length - 1 ? <div className={styles.stepLine} /> : null}
              </div>
            );
          })}
        </div>

        <div className={styles.body}>{children}</div>

        <div className={styles.foot}>{foot}</div>
      </div>
    </div>
  );
}
